export default "__VITE_ASSET__COIJB2bP__"